const attendanceStatusCodes = {
    UNAVAILABLE: 0,
    AVAILABLE: 1,
    ON_BREAK: 2,
    SERVING: 4,
    BUSY: 4
};

export { attendanceStatusCodes };